import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@one-thd/sui-atomic-components';
import { emailValidator } from '../../common/sharedFunctions';
import constants from '../../constants/constants';

export function EmailFieldFormatter({ name, value, callback }) {
  const isInvalid = value && !emailValidator(value);

  return (
    <TextField
      name={`email-${name}`}
      data-testid="email-input"
      label="Email Address"
      type="email"
      value={value}
      onChange={(event) => callback(event.target.value)}
      status={isInvalid ? 'error' : undefined}
      statusMessage={isInvalid ? constants.EMAIL_FIELD_VALIDATOR_ERROR_TEXT : undefined}
      fullWidth
    />
  );
}

EmailFieldFormatter.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
};

EmailFieldFormatter.defaultProps = {
  name: 'email-input'
};
